import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import MarketPriceTable from './tables/MarketPriceTable';
import { DatePicker, Select, TimePicker, Tooltip } from 'antd';
import Title from '../ui/Title';
import FormActionButton from '../ui/FormActionButton';
// import TransactionDetail from './TransactionDetail';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const MarketPrice = () => {
    const [productId, setProductId] = useState();
    const [issuerId, setIssuerId] = useState();
    const [customerId, setCustomerId] = useState();
    const [startDate, setStartDate] = useState({
        dateValue: '',
        dateString: '',
    });
    const [endDate, setEndDate] = useState({
        dateValue: '',
        dateString: '',
    });
    const [startTime, setStartTime] = useState({
        timeValue: '',
        timeString: '',
    });
    const [endTime, setEndTime] = useState({
        timeValue: '',
        timeString: '',
    });
    const [productIdList, setProductIdList] = useState([]);
    const [issuerIdList, setIssuerIdList] = useState([]);
    const [customerIdList, setCustomerIdList] = useState([]);

    const [dataSource, setDataSource] = useState([]);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // Get customer ID list
    useEffect(() => {
        (async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/customer/list`, {
                    method: 'GET',
                    headers: { 'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`) }
                });
                const responseData = await response.json();
                setCustomerIdList(responseData.data.map((product) => (
                    { value: product.customer_id, label: product.customer_name }
                )));
            } catch (error) {
                setIsError(true);
            }
        })();
    }, []);

    // Get product ID list
    useEffect(() => {
        if(customerId) {
            (async () => {
                try {
                    const details = {
                        'customer_id': customerId,
                    };
                
                    let formBody = [];
                    for (let property in details) {
                    let encodedKey = encodeURIComponent(property);
                    let encodedValue = encodeURIComponent(details[property]);
                    formBody.push(encodedKey + "=" + encodedValue);
                    }
                    formBody = formBody.join("&");

                    const response = await fetch(`${API_BASE_URL}/product_by_customer?customer_id=${customerId}`, {
                        method: 'POST',
                        headers: { 
                            'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
                            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                        },
                        body: formBody,
                    });
                    const responseData = await response.json();
                    setProductIdList(responseData.data.map((product) => (
                        { value: product.prod_id, label: product.prod_name }
                    )));
                } catch (error) {
                    setIsError(true);
                }
            })();
        }
    }, [customerId]);

    // Get issuer ID list
    useEffect(() => {
        (async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/issuer`, {
                    method: 'GET',
                    headers: { 'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`) }
                });
                const responseData = await response.json();
                setIssuerIdList(responseData.data.map((issuer) => (
                    {value: issuer.issuer_id, label: issuer.issuer_name}
                )));
            } catch (error) {
                setIsError(true);
            }
        })();
    }, []);

    // FETCH DATA
    useEffect(() => {
        
        let queryParams = `?`;
        if ((productId || issuerId || customerId || startDate.dateValue || endDate.dateValue || endTime.timeValue)) {
            if (customerId) {
                queryParams = queryParams.concat(`customer_id=${customerId}&`);
            }
            if (productId) {
                queryParams = queryParams.concat(`prod_id=${productId}&`);
            }
            if (issuerId) {
                queryParams = queryParams.concat(`issuer_id=${issuerId}&`);
            }
            if (startDate.dateString) {
                queryParams = queryParams.concat(`start_date=${startDate.dateString}&`);
            }
            if (endDate.dateString) {
                queryParams = queryParams.concat(`end_date=${endDate.dateString}&`);
            }
            if (startTime.timeString) {
                queryParams = queryParams.concat(`start_time=${startTime.timeString}&`);
            }
            if (endTime.timeString) {
                queryParams = queryParams.concat(`end_time=${endTime.timeString}&`);
            }
            queryParams = queryParams.slice(0, -1);

            if( !(queryParams.includes('customer_id') && queryParams.includes('prod_id') || 
                queryParams.includes('customer_id') && queryParams.includes('issuer_id')) ) {
                // DO NOTHING
            } else {
                fetchMarketPrice();
            }
        }
        if((!productId && !issuerId && !customerId && !startDate.dateValue && !endDate.dateValue && !startTime.timeValue && !endTime.timeValue)) {
            fetchMarketPrice();
        }
        
        async function fetchMarketPrice() {
            try {
                setIsLoading(true);
                setIsError(false);
                const response = await fetch(`${API_BASE_URL}/product${queryParams}`, {
                    method: 'POST',
                    headers: { 
                        'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                    },
                });
                const responseData = await response.json();
                if(responseData.code === 200) {
                    setDataSource(responseData.data.map((item) => ({
                        ...item,
                        key: item.market_price_id,
                    })));
                } else {
                    setDataSource([]);
                }
            } catch (error) {
                // Handle error
                setIsError(true);
                setIsLoading(false);
            }  
            setIsLoading(false);
        };

    }, [customerId, productId, issuerId, startDate, endDate, endTime]);

    useEffect(() => {
        if(!startDate.dateValue) {
            setEndDate({
                dateValue: null,
                dateString: '',
            });
        }
        if(!startTime.timeValue) {
            setEndTime({
                timeValue: null,
                timeString: '',
            });
        }
    }, [startDate, startTime]);

    const resetHandler = () => {
        setCustomerId();
        setProductId();
        setIssuerId();
        setStartDate({
            dateValue: null,
            dateString: '',
        });
        setEndDate({
            dateValue: null,
            dateString: '',
        });
        setStartTime({
            timeValue: null,
            timeString: '',
        });
        setEndTime({
            timeValue: null,
            timeString: '',
        });
        // setDataSource([]);
    }

    const productListDisabled = !customerId;
    const issuerListDisabled = !customerId;
    const startDateDisabled = !productId && !issuerId ;
    const endDateDisabled = !startDate.dateString;
    const timePickerDisabled = (!startDate.dateString) || (startDate.dateString && endDate.dateString);
    const endTimeDisabled = !startTime.timeString;

    return (
        <Wrapper>
            <Title>Market Price</Title>
            <SelectionGroup>
                <SelectionWrapper>
                    <Select
                        placeholder="Select Customer"
                        style={{ width: '100%'}}
                        size='large'
                        onChange={(value) => setCustomerId(value)}
                        value={customerId}
                        options={customerIdList}
                        allowClear
                    />
                </SelectionWrapper>
                <SelectionWrapper>
                    <Tooltip {...(productListDisabled && {title: 'Please select a Customer'})}>
                        <Select
                            placeholder="Select Product"
                            style={{ width: '100%'}}
                            size='large'
                            onChange={(value) => setProductId(value)}
                            value={productId}
                            options={productIdList}
                            allowClear
                            disabled={productListDisabled}
                        />
                    </Tooltip>
                </SelectionWrapper>
                <SelectionWrapper>
                    <Tooltip {...(issuerListDisabled && {title: 'Please select a Customer'})}>
                    <Select
                        placeholder="Select Issuer"
                        style={{ width: '100%'}}
                        size='large'
                        onChange={(value) => setIssuerId(value)}
                        value={issuerId}
                        options={issuerIdList}
                        allowClear
                        disabled={issuerListDisabled}
                    />
                    </Tooltip>
                </SelectionWrapper>
                </SelectionGroup>
                <div className="date-time">
                    <DateGroup>
                        <Tooltip {...(startDateDisabled && {title: 'Please select a Customer'})}>
                            <DatePicker 
                                onChange={(date, dateString) => setStartDate({dateValue: date, dateString: dateString})} 
                                value={startDate.dateValue}
                                size='large' 
                                style={{width: '100%', borderRadius: '0.2rem'}} 
                                placeholder='Select Start Date'
                                allowClear
                                disabled={startDateDisabled}
                            />
                        </Tooltip>
                    </DateGroup>
                    <DateGroup>
                        <Tooltip {...(endDateDisabled && {title: 'Please select start date'})}>
                            <DatePicker 
                                onChange={(date, dateString) => setEndDate({dateValue: date, dateString: dateString})} 
                                value={endDate.dateValue}
                                size='large' 
                                style={{width: '100%', borderRadius: '0.2rem'}} 
                                placeholder='Select End Date'
                                allowClear
                                disabled={endDateDisabled}
                            />
                        </Tooltip>
                    </DateGroup>
                        <TimeGroup>
                            <Tooltip {...(timePickerDisabled && {title: 'Please select start date only'})}>
                                <TimePicker  
                                    onChange={(time, timeString) => setStartTime({timeValue: time, timeString})} 
                                    value={startTime.timeValue} 
                                    size='large'
                                    style={{width: '100%', borderRadius: '0.2rem'}}
                                    placeholder='Select Start Time'
                                    allowClear
                                    disabled={timePickerDisabled}
                                />
                            </Tooltip>
                            <Tooltip {...(endTimeDisabled && {title: 'Please select start time'})}>
                                <TimePicker  
                                    onChange={(time, timeString) => setEndTime({timeValue: time, timeString})} 
                                    value={endTime.timeValue}
                                    size='large'
                                    style={{width: '100%', borderRadius: '0.2rem'}}
                                    placeholder='Select End Time'
                                    allowClear
                                    disabled={endTimeDisabled}
                                />
                            </Tooltip>
                        </TimeGroup>
                </div>
                <Action>
                    <div>
                        <FormActionButton bg='#ff6b6b' onClick={resetHandler} >Reset</FormActionButton>
                    </div>
                </Action>
            <MarketPriceTable dataSource={dataSource} isError={isError} isLoading={isLoading} />
        </Wrapper>
    );
}

export default MarketPrice;

const Wrapper = styled.div`
    width: 95%;
    margin: auto;
    .control {
        label {
            font-weight: bold;
            font-size: 1.5rem;
            letter-spacing: 0.0625rem;
            color: #36454F;
        }
    }
    .date-time {
        display: flex;
        justify-content: space-between;
        /* gap: 10rem; */
        gap: 2rem;
        margin-bottom: 2.5rem;
    }
    .ant-select .ant-select-selector {
        border-radius: 0.2rem;
    }
`;
const SelectionGroup = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 2rem;
    margin-bottom: 2.5rem;
`;
const SelectionWrapper = styled.div`
    flex: 1;
    /* display: flex; */
    max-width: 40rem;
`;
const DateGroup = styled.div`
    flex: 1;
    display: flex;
    max-width: 40rem;
    gap: 2rem;
`;
const TimeGroup = styled.div`
    flex: 1;
    display: flex;
    max-width: 40rem;
    gap: 2rem;
`;
const Action = styled.div`
    display: flex;
    justify-content: end;
`;
